var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8041 6.13319C15.5451 4.67796 14.2803 3.61891 12.8022 3.61891H12.6803C12.7641 3.38272 12.8098 3.12367 12.8098 2.857C12.8098 1.59986 11.7813 0.571289 10.5241 0.571289H7.47651C6.21937 0.571289 5.1908 1.59986 5.1908 2.857C5.1908 3.12367 5.23651 3.38272 5.32032 3.61891H5.19842C3.72032 3.61891 2.45556 4.67796 2.19651 6.13319L0.474609 15.8094H5.9527C5.9527 17.4932 7.31651 18.857 9.00032 18.857C10.6841 18.857 12.0479 17.4932 12.0479 15.8094H17.526L15.7965 6.13319H15.8041ZM6.71461 2.857C6.71461 2.43796 7.05747 2.0951 7.47651 2.0951H10.5241C10.9432 2.0951 11.286 2.43796 11.286 2.857C11.286 3.27605 10.9432 3.61891 10.5241 3.61891H7.47651C7.05747 3.61891 6.71461 3.27605 6.71461 2.857ZM9.00032 17.3332C8.16223 17.3332 7.47651 16.6475 7.47651 15.8094H10.5241C10.5241 16.6475 9.83842 17.3332 9.00032 17.3332ZM2.28794 14.2856L3.69747 6.39986C3.82699 5.66843 4.45937 5.14272 5.19842 5.14272H12.8022C13.5413 5.14272 14.1737 5.66843 14.3032 6.39986L15.7127 14.2856H2.28794Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.7da0a1f0d13be0978f481775f2e41d3a.svg";
export { ForwardRef as ReactComponent };